import styled from "styled-components";

import { Colors } from '../../constants'

export const Arrow = styled.div`
  position: absolute;
  background: inherit;
  &::before {
    position: absolute;
    width: 8px;
    height: 8px;
    background: inherit;
    content: '';
    transform: rotate(45deg);
  }
`;

export const Popper = styled.div`
  background: linear-gradient(0deg, rgba(16, 119, 185, 0.25), rgba(16, 119, 185, 0.25)), #FFFFFF;
  border-radius: 8px;
  filter: drop-shadow(0px 7px 8px rgba(0, 0, 0, 0.2)) drop-shadow(0px 12px 17px rgba(0, 0, 0, 0.14)) drop-shadow(0px 5px 22px rgba(0, 0, 0, 0.12));
  color: ${Colors.PRIMARY_LIGHT_DARK};
  font-size: 13px;
  display: ${(props) => props.open ? 'flex' : 'none'};

  &[data-popper-placement^='top'] > ${Arrow} {

  }

  &[data-popper-placement^='bottom'] > ${Arrow} {
    top: -4px;
    left: calc(1rem / 2) !important;
  }

  &[data-popper-placement^='left'] > ${Arrow} {
    right: -4px;
    top: calc(1rem / 2) !important;
  }

  &[data-popper-placement^='right'] > ${Arrow} {
    left: -4px;
    top: calc(1rem / 2) !important;
  }
`;

export const ContentPopper = styled.div`
  padding: 16px 10px;
`;

export const TitlePopper = styled.h4`
  font-weight: 600;
  font-size: 12px;
  color: ${Colors.PRIMARY_LIGHT_DARK};
  margin: 0;
  margin-bottom: 4px;
`;

export const DescriptionPopper = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: ${Colors.PRIMARY_BLUE};
`;

export const CloseButton = styled.button`
  background: inherit;
  border: none;
  color: ${Colors.SECONDARY_LIGHT_BLUE};
  margin-top: 8px;
  margin-right: 8px;

  &:hover .Icon {
    filter: brightness(0.5);
  }
`;
